export const TitleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.4129 10.5856C33.7878 10.9606 33.9984 11.4692 33.9984 11.9996C33.9984 12.5299 33.7878 13.0385 33.4129 13.4136L17.4129 29.4136C17.0378 29.7885 16.5292 29.9991 15.9989 29.9991C15.4685 29.9991 14.9599 29.7885 14.5849 29.4136L6.58486 21.4136C6.22054 21.0364 6.01896 20.5312 6.02351 20.0068C6.02807 19.4824 6.23841 18.9808 6.60922 18.6099C6.98004 18.2391 7.48166 18.0288 8.00606 18.0242C8.53045 18.0197 9.03566 18.2213 9.41286 18.5856L15.9989 25.1716L30.5849 10.5856C30.9599 10.2106 31.4685 10 31.9989 10C32.5292 10 33.0378 10.2106 33.4129 10.5856Z"
      fill="#111928"
    />
  </svg>
);

export const VideoIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      d="M4 12C4 10.9391 4.42143 9.92172 5.17157 9.17157C5.92172 8.42143 6.93913 8 8 8H20C21.0609 8 22.0783 8.42143 22.8284 9.17157C23.5786 9.92172 24 10.9391 24 12V28C24 29.0609 23.5786 30.0783 22.8284 30.8284C22.0783 31.5786 21.0609 32 20 32H8C6.93913 32 5.92172 31.5786 5.17157 30.8284C4.42143 30.0783 4 29.0609 4 28V12ZM29.106 14.212C28.7738 14.378 28.4944 14.6332 28.2991 14.9489C28.1038 15.2647 28.0002 15.6287 28 16V24C28.0002 24.3713 28.1038 24.7353 28.2991 25.0511C28.4944 25.3668 28.7738 25.622 29.106 25.788L33.106 27.788C33.4108 27.9403 33.7496 28.0122 34.09 27.9969C34.4304 27.9816 34.7613 27.8795 35.0512 27.7004C35.3411 27.5213 35.5805 27.271 35.7465 26.9735C35.9126 26.6759 35.9998 26.3408 36 26V14C35.9998 13.6592 35.9126 13.3241 35.7465 13.0265C35.5805 12.729 35.3411 12.4787 35.0512 12.2996C34.7613 12.1205 34.4304 12.0184 34.09 12.0031C33.7496 11.9878 33.4108 12.0597 33.106 12.212L29.106 14.212Z"
      fill="#111928"
    />
  </svg>
);

export const AssessmentIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.514 4.06749C24.068 4.21349 24.532 4.59145 24.79 5.10545C25.756 7.03946 26.478 8.21351 27.204 9.16551C27.94 10.1295 28.716 10.9175 29.9 12.0995C32.632 14.8335 34 18.4195 34 21.9995C34 25.5795 32.632 29.1655 29.9 31.8995C24.432 37.3655 15.568 37.3655 10.1 31.8995C7.36801 29.1655 6 25.5795 6 21.9995C6 18.4195 7.36801 14.8335 10.1 12.0995C10.672 11.5275 11.532 11.3575 12.28 11.6675C13.028 11.9755 13.514 12.7055 13.514 13.5135C13.514 15.7535 13.654 17.4595 14.31 18.8215C14.67 19.5695 15.232 20.3016 16.2 20.9556C16.432 18.8336 16.856 16.2475 17.428 13.7955C17.878 11.8635 18.438 9.9355 19.106 8.3275C19.44 7.5215 19.818 6.75745 20.246 6.09545C20.662 5.45145 21.198 4.79756 21.89 4.33556C22.368 4.01756 22.96 3.91949 23.514 4.06749ZM24.242 30.2414C21.9 32.5854 18.1 32.5854 15.758 30.2414C14.586 29.0714 14 27.5355 14 25.9995C14 25.9995 15.758 26.9995 19 26.9995C19 24.9995 20 18.9995 21.5 17.9995C22.5 19.9995 23.072 20.5856 24.242 21.7576C25.414 22.9276 26 24.4635 26 25.9995C26 27.5355 25.414 29.0714 24.242 30.2414Z"
      fill="#111928"
    />
  </svg>
);

export const ArticleIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4H21.172C22.2328 4.00023 23.25 4.4218 24 5.172L30.828 12C31.5782 12.75 31.9998 13.7672 32 14.828V32C32 33.0609 31.5786 34.0783 30.8284 34.8284C30.0783 35.5786 29.0609 36 28 36H12C10.9391 36 9.92172 35.5786 9.17157 34.8284C8.42143 34.0783 8 33.0609 8 32V8ZM12 20C12 19.4696 12.2107 18.9609 12.5858 18.5858C12.9609 18.2107 13.4696 18 14 18H26C26.5304 18 27.0391 18.2107 27.4142 18.5858C27.7893 18.9609 28 19.4696 28 20C28 20.5304 27.7893 21.0391 27.4142 21.4142C27.0391 21.7893 26.5304 22 26 22H14C13.4696 22 12.9609 21.7893 12.5858 21.4142C12.2107 21.0391 12 20.5304 12 20ZM14 26C13.4696 26 12.9609 26.2107 12.5858 26.5858C12.2107 26.9609 12 27.4696 12 28C12 28.5304 12.2107 29.0391 12.5858 29.4142C12.9609 29.7893 13.4696 30 14 30H26C26.5304 30 27.0391 29.7893 27.4142 29.4142C27.7893 29.0391 28 28.5304 28 28C28 27.4696 27.7893 26.9609 27.4142 26.5858C27.0391 26.2107 26.5304 26 26 26H14Z"
      fill="#111928"
    />
  </svg>
);

export const PictureIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 6C6.93913 6 5.92172 6.42143 5.17157 7.17157C4.42143 7.92172 4 8.93913 4 10V30C4 31.0609 4.42143 32.0783 5.17157 32.8284C5.92172 33.5786 6.93913 34 8 34H32C33.0609 34 34.0783 33.5786 34.8284 32.8284C35.5786 32.0783 36 31.0609 36 30V10C36 8.93913 35.5786 7.92172 34.8284 7.17157C34.0783 6.42143 33.0609 6 32 6H8ZM32 30H8L16 14L22 26L26 18L32 30Z"
      fill="#111928"
    />
  </svg>
);

export const ResourcesIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      d="M22.0011 6C21.4707 6 20.962 6.21071 20.5869 6.58579C20.2119 6.96086 20.0011 7.46957 20.0011 8C20.0011 8.53043 20.2119 9.03914 20.5869 9.41421C20.962 9.78929 21.4707 10 22.0011 10H27.1731L14.5871 22.586C14.3961 22.7705 14.2438 22.9912 14.1389 23.2352C14.0341 23.4792 13.9789 23.7416 13.9766 24.0072C13.9743 24.2728 14.0249 24.5361 14.1255 24.7819C14.2261 25.0277 14.3746 25.251 14.5623 25.4388C14.7501 25.6266 14.9734 25.7751 15.2192 25.8756C15.465 25.9762 15.7284 26.0268 15.9939 26.0245C16.2595 26.0222 16.5219 25.967 16.7659 25.8622C17.01 25.7574 17.2306 25.605 17.4151 25.414L30.0011 12.828V18C30.0011 18.5304 30.2119 19.0391 30.5869 19.4142C30.962 19.7893 31.4707 20 32.0011 20C32.5316 20 33.0403 19.7893 33.4154 19.4142C33.7904 19.0391 34.0011 18.5304 34.0011 18V8C34.0011 7.46957 33.7904 6.96086 33.4154 6.58579C33.0403 6.21071 32.5316 6 32.0011 6H22.0011Z"
      fill="#111928"
    />
    <path
      d="M10 10C8.93913 10 7.92172 10.4214 7.17157 11.1716C6.42143 11.9217 6 12.9391 6 14V30C6 31.0609 6.42143 32.0783 7.17157 32.8284C7.92172 33.5786 8.93913 34 10 34H26C27.0609 34 28.0783 33.5786 28.8284 32.8284C29.5786 32.0783 30 31.0609 30 30V24C30 23.4696 29.7893 22.9609 29.4142 22.5858C29.0391 22.2107 28.5304 22 28 22C27.4696 22 26.9609 22.2107 26.5858 22.5858C26.2107 22.9609 26 23.4696 26 24V30H10V14H16C16.5304 14 17.0391 13.7893 17.4142 13.4142C17.7893 13.0391 18 12.5304 18 12C18 11.4696 17.7893 10.9609 17.4142 10.5858C17.0391 10.2107 16.5304 10 16 10H10Z"
      fill="black"
    />
  </svg>
);

export const PollingIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cms-icon"
  >
    <path
      d="M4 22C4 21.4696 4.21071 20.9609 4.58579 20.5858C4.96086 20.2107 5.46957 20 6 20H10C10.5304 20 11.0391 20.2107 11.4142 20.5858C11.7893 20.9609 12 21.4696 12 22V32C12 32.5304 11.7893 33.0391 11.4142 33.4142C11.0391 33.7893 10.5304 34 10 34H6C5.46957 34 4.96086 33.7893 4.58579 33.4142C4.21071 33.0391 4 32.5304 4 32V22ZM16 14C16 13.4696 16.2107 12.9609 16.5858 12.5858C16.9609 12.2107 17.4696 12 18 12H22C22.5304 12 23.0391 12.2107 23.4142 12.5858C23.7893 12.9609 24 13.4696 24 14V32C24 32.5304 23.7893 33.0391 23.4142 33.4142C23.0391 33.7893 22.5304 34 22 34H18C17.4696 34 16.9609 33.7893 16.5858 33.4142C16.2107 33.0391 16 32.5304 16 32V14ZM28 8C28 7.46957 28.2107 6.96086 28.5858 6.58579C28.9609 6.21071 29.4696 6 30 6H34C34.5304 6 35.0391 6.21071 35.4142 6.58579C35.7893 6.96086 36 7.46957 36 8V32C36 32.5304 35.7893 33.0391 35.4142 33.4142C35.0391 33.7893 34.5304 34 34 34H30C29.4696 34 28.9609 33.7893 28.5858 33.4142C28.2107 33.0391 28 32.5304 28 32V8Z"
      fill="#111928"
    />
  </svg>
);

export const ShuffleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="9" r="2" fill="#D1D5DB" />
    <circle cx="15" cy="15" r="2" fill="#D1D5DB" />
    <circle cx="15" cy="21" r="2" fill="#D1D5DB" />
    <circle cx="15" cy="3" r="2" fill="#D1D5DB" />
    <circle cx="9" cy="9" r="2" fill="#D1D5DB" />
    <circle cx="9" cy="15" r="2" fill="#D1D5DB" />
    <circle cx="9" cy="21" r="2" fill="#D1D5DB" />
    <circle cx="9" cy="3" r="2" fill="#D1D5DB" />
  </svg>
);

export const VideoUploadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25 16.6667L32.5883 12.8733C32.8424 12.7464 33.1246 12.6865 33.4083 12.6992C33.692 12.712 33.9677 12.7971 34.2093 12.9463C34.4509 13.0956 34.6504 13.3041 34.7888 13.5521C34.9271 13.8001 34.9998 14.0793 35 14.3633V25.6367C34.9998 25.9207 34.9271 26.1999 34.7888 26.4479C34.6504 26.6959 34.4509 26.9044 34.2093 27.0537C33.9677 27.2029 33.692 27.288 33.4083 27.3008C33.1246 27.3135 32.8424 27.2536 32.5883 27.1267L25 23.3333V16.6667ZM8.33333 30H21.6667C22.5507 30 23.3986 29.6488 24.0237 29.0237C24.6488 28.3986 25 27.5507 25 26.6667V13.3333C25 12.4493 24.6488 11.6014 24.0237 10.9763C23.3986 10.3512 22.5507 10 21.6667 10H8.33333C7.44928 10 6.60143 10.3512 5.97631 10.9763C5.35119 11.6014 5 12.4493 5 13.3333V26.6667C5 27.5507 5.35119 28.3986 5.97631 29.0237C6.60143 29.6488 7.44928 30 8.33333 30Z"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AudioUploadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0002 22.3737C18.8057 22.3737 17.8057 21.9431 17.0002 21.082C16.1946 20.2209 15.7918 19.1793 15.7918 17.957V7.4987C15.7918 6.33203 16.2016 5.34592 17.021 4.54036C17.8404 3.73481 18.8335 3.33203 20.0002 3.33203C21.1668 3.33203 22.1599 3.73481 22.9793 4.54036C23.7988 5.34592 24.2085 6.33203 24.2085 7.4987V17.957C24.2085 19.1793 23.8057 20.2209 23.0002 21.082C22.1946 21.9431 21.1946 22.3737 20.0002 22.3737ZM20.0002 34.9987C19.6391 34.9987 19.3404 34.8806 19.1043 34.6445C18.8682 34.4084 18.7502 34.1098 18.7502 33.7487V29.332C16.0279 29.0265 13.7016 27.9362 11.771 26.0612C9.84045 24.1862 8.72239 21.9293 8.41684 19.2904C8.36128 18.9293 8.46545 18.6168 8.72934 18.3529C8.99323 18.089 9.31961 17.957 9.7085 17.957C10.0141 17.957 10.2779 18.0681 10.5002 18.2904C10.7224 18.5126 10.8613 18.7765 10.9168 19.082C11.2224 21.332 12.2224 23.2001 13.9168 24.6862C15.6113 26.1723 17.6391 26.9154 20.0002 26.9154C22.3613 26.9154 24.3891 26.1723 26.0835 24.6862C27.7779 23.2001 28.7779 21.332 29.0835 19.082C29.1391 18.7765 29.2849 18.5126 29.521 18.2904C29.7571 18.0681 30.0279 17.957 30.3335 17.957C30.7224 17.957 31.0418 18.089 31.2918 18.3529C31.5418 18.6168 31.6391 18.9293 31.5835 19.2904C31.2779 21.9293 30.1599 24.1862 28.2293 26.0612C26.2988 27.9362 23.9724 29.0265 21.2502 29.332V33.7487C21.2502 34.1098 21.1321 34.4084 20.896 34.6445C20.6599 34.8806 20.3613 34.9987 20.0002 34.9987Z"
      fill="#6B7280"
      stroke="#6B7280"
    />
  </svg>
);

export const AudioIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0002 22.3737C18.8057 22.3737 17.8057 21.9431 17.0002 21.082C16.1946 20.2209 15.7918 19.1793 15.7918 17.957V7.4987C15.7918 6.33203 16.2016 5.34592 17.021 4.54036C17.8404 3.73481 18.8335 3.33203 20.0002 3.33203C21.1668 3.33203 22.1599 3.73481 22.9793 4.54036C23.7988 5.34592 24.2085 6.33203 24.2085 7.4987V17.957C24.2085 19.1793 23.8057 20.2209 23.0002 21.082C22.1946 21.9431 21.1946 22.3737 20.0002 22.3737ZM20.0002 34.9987C19.6391 34.9987 19.3404 34.8806 19.1043 34.6445C18.8682 34.4084 18.7502 34.1098 18.7502 33.7487V29.332C16.0279 29.0265 13.7016 27.9362 11.771 26.0612C9.84045 24.1862 8.72239 21.9293 8.41684 19.2904C8.36128 18.9293 8.46545 18.6168 8.72934 18.3529C8.99323 18.089 9.31961 17.957 9.7085 17.957C10.0141 17.957 10.2779 18.0681 10.5002 18.2904C10.7224 18.5126 10.8613 18.7765 10.9168 19.082C11.2224 21.332 12.2224 23.2001 13.9168 24.6862C15.6113 26.1723 17.6391 26.9154 20.0002 26.9154C22.3613 26.9154 24.3891 26.1723 26.0835 24.6862C27.7779 23.2001 28.7779 21.332 29.0835 19.082C29.1391 18.7765 29.2849 18.5126 29.521 18.2904C29.7571 18.0681 30.0279 17.957 30.3335 17.957C30.7224 17.957 31.0418 18.089 31.2918 18.3529C31.5418 18.6168 31.6391 18.9293 31.5835 19.2904C31.2779 21.9293 30.1599 24.1862 28.2293 26.0612C26.2988 27.9362 23.9724 29.0265 21.2502 29.332V33.7487C21.2502 34.1098 21.1321 34.4084 20.896 34.6445C20.6599 34.8806 20.3613 34.9987 20.0002 34.9987Z"
      fill="#111928"
      stroke="#111928"
    />
  </svg>
);

export const ImageUploadIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66797 26.668L14.3113 19.0246C14.9364 18.3997 15.7841 18.0487 16.668 18.0487C17.5518 18.0487 18.3995 18.3997 19.0246 19.0246L26.668 26.668M23.3346 23.3346L25.978 20.6913C26.6031 20.0664 27.4508 19.7153 28.3346 19.7153C29.2185 19.7153 30.0662 20.0664 30.6913 20.6913L33.3346 23.3346M23.3346 13.3346H23.3513M10.0013 33.3346H30.0013C30.8854 33.3346 31.7332 32.9834 32.3583 32.3583C32.9834 31.7332 33.3346 30.8854 33.3346 30.0013V10.0013C33.3346 9.11725 32.9834 8.2694 32.3583 7.64428C31.7332 7.01916 30.8854 6.66797 30.0013 6.66797H10.0013C9.11725 6.66797 8.2694 7.01916 7.64428 7.64428C7.01916 8.2694 6.66797 9.11725 6.66797 10.0013V30.0013C6.66797 30.8854 7.01916 31.7332 7.64428 32.3583C8.2694 32.9834 9.11725 33.3346 10.0013 33.3346Z"
      stroke="#6B7280"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="custom-icon delete-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8016 2.39844C10.5788 2.39856 10.3604 2.4607 10.1709 2.5779C9.98146 2.6951 9.82835 2.86274 9.72876 3.06204L8.85996 4.79844H4.80156C4.4833 4.79844 4.17808 4.92487 3.95303 5.14991C3.72799 5.37495 3.60156 5.68018 3.60156 5.99844C3.60156 6.3167 3.72799 6.62192 3.95303 6.84697C4.17808 7.07201 4.4833 7.19844 4.80156 7.19844V19.1984C4.80156 19.835 5.05442 20.4454 5.50451 20.8955C5.95459 21.3456 6.56504 21.5984 7.20156 21.5984H16.8016C17.4381 21.5984 18.0485 21.3456 18.4986 20.8955C18.9487 20.4454 19.2016 19.835 19.2016 19.1984V7.19844C19.5198 7.19844 19.825 7.07201 20.0501 6.84697C20.2751 6.62192 20.4016 6.3167 20.4016 5.99844C20.4016 5.68018 20.2751 5.37495 20.0501 5.14991C19.825 4.92487 19.5198 4.79844 19.2016 4.79844H15.1432L14.2744 3.06204C14.1748 2.86274 14.0217 2.6951 13.8322 2.5779C13.6427 2.4607 13.4244 2.39856 13.2016 2.39844H10.8016ZM8.40156 9.59844C8.40156 9.28018 8.52799 8.97495 8.75303 8.74991C8.97808 8.52487 9.2833 8.39844 9.60156 8.39844C9.91982 8.39844 10.225 8.52487 10.4501 8.74991C10.6751 8.97495 10.8016 9.28018 10.8016 9.59844V16.7984C10.8016 17.1167 10.6751 17.4219 10.4501 17.647C10.225 17.872 9.91982 17.9984 9.60156 17.9984C9.2833 17.9984 8.97808 17.872 8.75303 17.647C8.52799 17.4219 8.40156 17.1167 8.40156 16.7984V9.59844ZM14.4016 8.39844C14.0833 8.39844 13.7781 8.52487 13.553 8.74991C13.328 8.97495 13.2016 9.28018 13.2016 9.59844V16.7984C13.2016 17.1167 13.328 17.4219 13.553 17.647C13.7781 17.872 14.0833 17.9984 14.4016 17.9984C14.7198 17.9984 15.025 17.872 15.2501 17.647C15.4751 17.4219 15.6016 17.1167 15.6016 16.7984V9.59844C15.6016 9.28018 15.4751 8.97495 15.2501 8.74991C15.025 8.52487 14.7198 8.39844 14.4016 8.39844Z"
      fill="#6B7280"
      className="custom-path"
    />
  </svg>
);

export const LessonMCQIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0362 5.26351C15.2049 5.43228 15.2997 5.66116 15.2997 5.89981C15.2997 6.13846 15.2049 6.36733 15.0362 6.53611L7.83618 13.7361C7.6674 13.9048 7.43853 13.9996 7.19988 13.9996C6.96123 13.9996 6.73235 13.9048 6.56358 13.7361L2.96358 10.1361C2.79964 9.96637 2.70892 9.73902 2.71097 9.50305C2.71302 9.26707 2.80767 9.04134 2.97454 8.87447C3.14141 8.7076 3.36714 8.61295 3.60312 8.6109C3.83909 8.60885 4.06644 8.69957 4.23618 8.86351L7.19988 11.8272L13.7636 5.26351C13.9324 5.09478 14.1612 5 14.3999 5C14.6385 5 14.8674 5.09478 15.0362 5.26351Z"
      fill="#111928"
    />
  </svg>
);

export const LessonSliderIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.80078 10.3992C1.80078 10.1605 1.8956 9.93161 2.06439 9.76282C2.23317 9.59404 2.46209 9.49922 2.70078 9.49922H4.50078C4.73948 9.49922 4.96839 9.59404 5.13718 9.76282C5.30596 9.93161 5.40078 10.1605 5.40078 10.3992V14.8992C5.40078 15.1379 5.30596 15.3668 5.13718 15.5356C4.96839 15.7044 4.73948 15.7992 4.50078 15.7992H2.70078C2.46209 15.7992 2.23317 15.7044 2.06439 15.5356C1.8956 15.3668 1.80078 15.1379 1.80078 14.8992V10.3992ZM7.20078 6.79922C7.20078 6.56052 7.2956 6.33161 7.46438 6.16282C7.63317 5.99404 7.86209 5.89922 8.10078 5.89922H9.90078C10.1395 5.89922 10.3684 5.99404 10.5372 6.16282C10.706 6.33161 10.8008 6.56052 10.8008 6.79922V14.8992C10.8008 15.1379 10.706 15.3668 10.5372 15.5356C10.3684 15.7044 10.1395 15.7992 9.90078 15.7992H8.10078C7.86209 15.7992 7.63317 15.7044 7.46438 15.5356C7.2956 15.3668 7.20078 15.1379 7.20078 14.8992V6.79922ZM12.6008 4.09922C12.6008 3.86052 12.6956 3.63161 12.8644 3.46282C13.0332 3.29404 13.2621 3.19922 13.5008 3.19922H15.3008C15.5395 3.19922 15.7684 3.29404 15.9372 3.46282C16.106 3.63161 16.2008 3.86052 16.2008 4.09922V14.8992C16.2008 15.1379 16.106 15.3668 15.9372 15.5356C15.7684 15.7044 15.5395 15.7992 15.3008 15.7992H13.5008C13.2621 15.7992 13.0332 15.7044 12.8644 15.5356C12.6956 15.3668 12.6008 15.1379 12.6008 14.8992V4.09922Z"
      fill="#111928"
    />
  </svg>
);

export const LessonTimerIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00078 16.7008C10.9103 16.7008 12.7417 15.9422 14.0919 14.5919C15.4422 13.2417 16.2008 11.4103 16.2008 9.50078C16.2008 7.59122 15.4422 5.75987 14.0919 4.40961C12.7417 3.05935 10.9103 2.30078 9.00078 2.30078C7.09122 2.30078 5.25987 3.05935 3.90961 4.40961C2.55935 5.75987 1.80078 7.59122 1.80078 9.50078C1.80078 11.4103 2.55935 13.2417 3.90961 14.5919C5.25987 15.9422 7.09122 16.7008 9.00078 16.7008ZM9.90078 5.90078C9.90078 5.66209 9.80596 5.43317 9.63718 5.26438C9.46839 5.0956 9.23948 5.00078 9.00078 5.00078C8.76209 5.00078 8.53317 5.0956 8.36438 5.26438C8.1956 5.43317 8.10078 5.66209 8.10078 5.90078V9.50078C8.10083 9.73946 8.19569 9.96834 8.36448 10.1371L10.9097 12.6832C10.9933 12.7668 11.0926 12.8331 11.2018 12.8784C11.3111 12.9236 11.4282 12.9469 11.5464 12.9469C11.6647 12.9469 11.7818 12.9236 11.891 12.8784C12.0003 12.8331 12.0996 12.7668 12.1832 12.6832C12.2668 12.5996 12.3331 12.5003 12.3784 12.391C12.4236 12.2818 12.4469 12.1647 12.4469 12.0464C12.4469 11.9282 12.4236 11.8111 12.3784 11.7018C12.3331 11.5926 12.2668 11.4933 12.1832 11.4097L9.90078 9.12818V5.90078Z"
      fill="#111928"
    />
  </svg>
);

export const LessonQuizIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2008 9.50078C16.2008 11.4103 15.4422 13.2417 14.0919 14.5919C12.7417 15.9422 10.9103 16.7008 9.00078 16.7008C7.09122 16.7008 5.25987 15.9422 3.90961 14.5919C2.55935 13.2417 1.80078 11.4103 1.80078 9.50078C1.80078 7.59122 2.55935 5.75987 3.90961 4.40961C5.25987 3.05935 7.09122 2.30078 9.00078 2.30078C10.9103 2.30078 12.7417 3.05935 14.0919 4.40961C15.4422 5.75987 16.2008 7.59122 16.2008 9.50078ZM9.00078 6.80078C8.84265 6.80063 8.68727 6.84214 8.55028 6.92114C8.4133 7.00014 8.29955 7.11383 8.22048 7.25078C8.16339 7.35687 8.08558 7.45042 7.99167 7.52588C7.89775 7.60133 7.78964 7.65717 7.67375 7.69007C7.55785 7.72297 7.43653 7.73227 7.31698 7.71742C7.19742 7.70256 7.08207 7.66386 6.97775 7.60359C6.87343 7.54333 6.78227 7.46273 6.70968 7.36658C6.63709 7.27043 6.58454 7.16069 6.55515 7.04386C6.52575 6.92702 6.52012 6.80548 6.53857 6.68642C6.55703 6.56737 6.5992 6.45323 6.66258 6.35078C6.95978 5.83608 7.4185 5.43383 7.9676 5.2064C8.51671 4.97897 9.12551 4.93907 9.6996 5.0929C10.2737 5.24673 10.781 5.58569 11.1428 6.0572C11.5046 6.52872 11.7008 7.10644 11.7008 7.70078C11.7009 8.25934 11.5279 8.8042 11.2056 9.26035C10.8832 9.71649 10.4273 10.0615 9.90078 10.2478V10.4008C9.90078 10.6395 9.80596 10.8684 9.63718 11.0372C9.46839 11.206 9.23948 11.3008 9.00078 11.3008C8.76209 11.3008 8.53317 11.206 8.36438 11.0372C8.1956 10.8684 8.10078 10.6395 8.10078 10.4008V9.50078C8.10078 9.26209 8.1956 9.03317 8.36438 8.86438C8.53317 8.6956 8.76209 8.60078 9.00078 8.60078C9.23948 8.60078 9.46839 8.50596 9.63718 8.33718C9.80596 8.16839 9.90078 7.93948 9.90078 7.70078C9.90078 7.46209 9.80596 7.23317 9.63718 7.06438C9.46839 6.8956 9.23948 6.80078 9.00078 6.80078ZM9.00078 14.0008C9.23948 14.0008 9.46839 13.906 9.63718 13.7372C9.80596 13.5684 9.90078 13.3395 9.90078 13.1008C9.90078 12.8621 9.80596 12.6332 9.63718 12.4644C9.46839 12.2956 9.23948 12.2008 9.00078 12.2008C8.76209 12.2008 8.53317 12.2956 8.36438 12.4644C8.1956 12.6332 8.10078 12.8621 8.10078 13.1008C8.10078 13.3395 8.1956 13.5684 8.36438 13.7372C8.53317 13.906 8.76209 14.0008 9.00078 14.0008Z"
      fill="#111928"
    />
  </svg>
);

export const CommentIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="custom-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 5V13C18 13.5304 17.7893 14.0391 17.4142 14.4142C17.0391 14.7893 16.5304 15 16 15H11L6 19V15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H16C16.5304 3 17.0391 3.21071 17.4142 3.58579C17.7893 3.96086 18 4.46957 18 5ZM7 8H5V10H7V8ZM9 8H11V10H9V8ZM15 8H13V10H15V8Z"
      fill="#111928"
      className="custom-path"
    />
  </svg>
);

export const ReviewIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="custom-icon"
  >
    <path
      d="M9.04897 2.92513C9.34897 2.00412 10.652 2.00412 10.951 2.92513L12.021 6.21712C12.0863 6.41761 12.2134 6.5923 12.384 6.71623C12.5547 6.84015 12.7601 6.90697 12.971 6.90712H16.433C17.402 6.90712 17.804 8.14712 17.021 8.71712L14.221 10.7511C14.05 10.8752 13.9227 11.0501 13.8573 11.251C13.7919 11.4518 13.7918 11.6682 13.857 11.8691L14.927 15.1611C15.227 16.0821 14.172 16.8491 13.387 16.2791L10.587 14.2451C10.4162 14.1211 10.2105 14.0543 9.99947 14.0543C9.78842 14.0543 9.58277 14.1211 9.41197 14.2451L6.61197 16.2791C5.82797 16.8491 4.77397 16.0821 5.07297 15.1611L6.14297 11.8691C6.20815 11.6682 6.20803 11.4518 6.14264 11.251C6.07725 11.0501 5.94994 10.8752 5.77897 10.7511L2.97997 8.71813C2.19697 8.14813 2.59997 6.90812 3.56797 6.90812H7.02897C7.24002 6.90818 7.44568 6.84146 7.6165 6.71752C7.78732 6.59358 7.91455 6.41878 7.97997 6.21812L9.04997 2.92612L9.04897 2.92513Z"
      fill="#111928"
      className="custom-path"
    />
  </svg>
);

export const ReviewStarUnFilledIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7501_35863)">
      <path
        d="M12 7.13L12.97 9.42L13.44 10.53L14.64 10.63L17.11 10.84L15.23 12.47L14.32 13.26L14.59 14.44L15.15 16.85L13.03 15.57L12 14.93L10.97 15.55L8.85 16.83L9.41 14.42L9.68 13.24L8.77 12.45L6.89 10.82L9.36 10.61L10.56 10.51L11.03 9.4L12 7.13ZM12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2Z"
        fill="#BDBDBD"
      />
    </g>
    <defs>
      <clipPath id="clip0_7501_35863">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ReviewStarFilledIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7501_35857)">
      <path
        d="M12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2Z"
        fill="#E3A008"
      />
    </g>
    <defs>
      <clipPath id="clip0_7501_35857">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
